module.exports = __webpack_public_path__ + "static/media/relax_set.b421334f.jpg";